import { Navigate, useLocation, useParams } from "react-router-dom";
import { useSub } from "../../../../common/subscription/useSub";
import { urls } from "../../../../urls";
import { BasicSourcingEventView } from "./BasicSourcingEventView";

export const BseViewRoute = () => {
  const sub = useSub();
  const { eventId } = useParams();
  const location = useLocation();

  if (sub.hasSourcingEventV2Access && eventId) {
    return <Navigate to={`${urls.v2.sourcingEvents.bseView.go(eventId)}${location.search}${location.hash}`} replace />;
  }

  return <BasicSourcingEventView />;
};
